import { useMutation } from '@tanstack/react-query';

import { type ParkingAPIConfig } from 'src/features/parkingManagement/api/useParkingAPIConfigs';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { GeneralSmartParkError } from 'src/types/errors';

interface DTO {
    parkingId: string;
}

const RESOURCE = '/parkings/:parkingId/parking-api-client-configs/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<ParkingAPIConfig> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateParkingAPIConfigs };
